import { START_SPICE_CARD_RUN } from "../actionTypes";

export const startSpiceCardRun = (channelId, verificationId) => ({
  type: START_SPICE_CARD_RUN,
  channelId,
  verificationId
})